import { createStyles } from "@mantine/styles";

export const useStyle = createStyles(() => ({
  container: {
    padding: "60px",
  },
  header: {
    fontSize: "20px",
  },
  body: {
    marginTop: "30px",
    marginBottom: "30px",
  },
  buttonGroup: {
    marginTop: "30px",
    borderRadius: "10px",
  },
  radio: {
    marginBottom: "50px",
  },
}));
